 <div class="flex h-10 w-10 items-center justify-center rounded-full border"   (click)="refreshTable()">
      <img
        src="assets/images/svgs/repeat--gray.svg"
        alt=""
        class="cursor-pointer"
      />
</div>